import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import Grid from './Grid';

const CasesToBeAdvanced = () => {
  const makeMenuItemActive = () => {
    document.querySelector('#menuitem-accounting').click();
    document
      .querySelector('#kt_header_tab_5 > div > div > ul > li:nth-child(1)')
      .classList.add('menu-item-active');
  };

  useEffect(() => makeMenuItemActive(), []);

  return (
    <div className="container mt-10 mb-10" style={{ maxWidth: '95%' }}>
      <div className="row">
        <div className="col-md-12 bg-white box-shadow-border">
          <div style={{ padding: '0.5rem' }}>
            <div className="d-flex mt-5 mb-10">
              <div className="mr-auto">
                <h1>Cases to Be Advanced</h1>
              </div>
            </div>
            <Row>
              <Col md="12">
                <Grid />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CasesToBeAdvanced;
